// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".days-week {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n}\n.week-text {\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n  color: #000000;\n}\n.active {\n  background: #F0A4D2;\n  color: #FFFFFF;\n  width: 130px;\n  height: 40px;\n  border-radius: 5px;\n  font-style: normal;\n  font-weight: 400;\n  font-size: 18px;\n}\n\n/* ::-webkit-scrollbar {\n    width: 0px;\n} */\n", ""]);
// Exports
module.exports = exports;
